/** Extract a single string from a route query value (which may be string, array, or null). */
export const getStringQueryValue = (value: unknown): string => {
    if (typeof value === 'string') {
        return value;
    }

    if (Array.isArray(value) && typeof value[0] === 'string') {
        return value[0];
    }

    return '';
};
